export default function FloatToPercParser(value: number) {
    return `${value}%`;
}
